import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from './../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, delay, Observable, retry, Subject} from 'rxjs';

import { Subscription } from 'rxjs';


import { NgForm } from '@angular/forms';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

import { SubjectBillingItem } from '../../../shared/models/subjectBillingItem.model';

import { SubjectInvoiceItem } from '../../../shared/models/subjectInvoiceItem.model';


import { Payment } from './../../../shared/models/payment.model';
import { InvoicePayment } from '../../../shared/models/invoicePayment.model';

// Import the MyoAPIPaymentsToolsWidget - to use the functions
// place in the providers of the page.
import { MyobApiInvoicePaymentSyncToolsWidgetComponent } from './../../../components/myob/myob-api-invoice-payment-sync-tools-widget/myob-api-invoice-payment-sync-tools-widget.component';
import { MyobApiInvoiceSyncToolsWidgetComponent } from './../../../components/myob/myob-api-invoice-sync-tools-widget/myob-api-invoice-sync-tools-widget.component'

@Component({
  selector: 'app-invoice-payment-widget',
  templateUrl: './invoice-payment-widget.component.html',
  styleUrls: ['./invoice-payment-widget.component.css']
})
export class InvoicePaymentWidgetComponent implements OnInit, OnChanges {

  
  @Input() job_id;
  @Input() subject_id;
  @Input() subject_number;
  @Input() job_number;

  @Input() invoice_id?: Observable<any[]>; // impliments on changes.
  @Input() invoice_number?; // impliments on changes.

  // setup as observable?
  @Input() item_id?: Observable<any[]>; // impliments on changes.
  @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'side'; // side | abstract | full
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  @Output('refreshParentGrid') refreshParentGrid: EventEmitter<any> = new EventEmitter();
  @Output('refreshInvoiceItemsBelow') refreshInvoiceItemsBelow: EventEmitter<any> = new EventEmitter();
 paymentModel: any = Payment;
  invoicePaymentModel: InvoicePayment;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  invoice_payment: any;
  modalRef: BsModalRef;
  invoice_deleted_data: Object;

  invoice_update_payment_model: any = [];
  payment: Object;
  subject_invoices: Object;
  current_invoice_id: any;
  subject_invoice: Object;
  current_invoiceUID: any;

  
  @Input() payment_id?: number;
  response_from_node: string;
  response_from_node_raw: any;
  current_paymentUID: any;
  

  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     public myobApi_IPTW: MyobApiInvoicePaymentSyncToolsWidgetComponent,
     public myobApi_ITW: MyobApiInvoiceSyncToolsWidgetComponent,
  ) {
 
  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
 
       // need to add this as routes does not work globally
       this.all_router_details = this.router.url;
       this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
 
  // this.toastr.setRootViewContainerRef(vcr);
 
   }
 
   // check for changes. to load data.
   ngOnChanges(changes) {
 
 
 this.paymentModel = new Payment();  // starts a new empty payment model
 this.invoicePaymentModel = new InvoicePayment();  // starts a new empty payment model
 this.getInvoicePayments(this.invoice_id);
 this.getInvoice(this.invoice_id); // load the invoice data for the myob updates


 
    if (changes.invoice_id) {
      

      // this.paymentModel = new Payment();  // starts a new empty payment model
      // this.invoicePaymentModel = new InvoicePayment();  // starts a new empty payment model
      // this.getInvoicePayments(this.invoice_id);
      // this.getInvoice(this.invoice_id); // load the invoice data for the myob updates
     
     
      // deal with asynchronous Observable result
     // this.invoice_id = changes.invoice_id.currentValue;
     // this.getInvoice(this.invoice_id);
     // this.getMyobAccountCodes();
 
    }
  }
 
 
  ngOnInit() {
   // this.getInvoice(this.invoice_id);
   // this.getMyobAccountCodes();
  }


  getPayment(payment_id){
    this._demoService.getPayment(payment_id).subscribe(
      (data) => {
        this.payment = data;
        let res = data[0];
        this.current_paymentUID = this.payment[0].myob_id;
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }



  getInvoicePayments(invoice_id){
    this._demoService.getInvoicePayments(invoice_id).subscribe(
      (data) => {
        this.invoice_payment = data;
        this.getPayment(this.invoice_payment[0].payment_id)
        let res = data[0];
      },
      (err) => console.error(err),
     // () => console.log('Brand Loaded.')
    );
  }


  getInvoice(invoice_id){
    this._demoService.getSubjectInvoice(invoice_id).subscribe(
      data => {
        this.subject_invoice = data;
    let res = data[0];
    this.current_invoice_id = res.invoice_id;
    this.current_invoiceUID = res.UID;
    return true;
       },
      err => {
      console.error(err);
      return JSON.stringify(err);
      },

      // () => console.log('done loading Trace Types')
    );
  }


  /*


See what happens...

Can simply edit and change the invoice after I do this.... test this in next action.
I need to be able to have access to delete the invoice to edit after a payment has been deleted.

  */


  getPaymentForDeleteMyobandSop(model){

// 07/02/24
this.gfunc.myobChecker();

    this.getInvoice(model.invoice_id); // to ensure we have teh current_invocieID set from another component // feb 2023 adition making tit work as is supposed to .
    if (confirm('Are you sure you want to delete this payment entry in both myob and sop?')) {
    this._demoService.getPayment(model.payment_id)
    .pipe(
      this.toastr.observe({
        loading: 'Connecting...Pushing...Updating',
        success: '🚀',
        error: '😡 Error Deleting Invoice Payment'
     })
     ).subscribe(
      (data) => {
        this.payment = data;
        this.paymentModel = this.payment;
        let res = data[0];
          console.log('Deleted Payment Myob Model IS ther an Invoice ID? ' + JSON.stringify(this.paymentModel));
        // MYOB Live delete payment (Does all the myob stuff from the ToolsComponent.)
        // needed to be strinigyied of javascript return array.
        // this.myobApi_IPTW.deleteMyobServiceInvoicePaymentModel(this.paymentModel);
        // this.myobApi_IPTW.deleteMyobServiceInvoicePaymentModel(res);
        // Now to try and skip this test (skip load of all payment data's agan om the button widget)
        // this.myobApi_IPTW.deleteMyobServiceInvoicePaymentModel(res);
        // tslint:disable-next-line:max-line-length
        this.getInvoice(model.invoice_id); // so that we have the variable later to later to upload the row versions // added this as per the supplers october 2022
        this.myobApi_IPTW.deleteMyobServiceInvoicePaymentModelStep2(res, this.current_invoiceUID); // added invoice ID so that it refreshes the invoice rows after payemnt deleteion

        // then delete from SOP
        // model.UID = this.paymentModel.invoice_UID;


      },
      (err) => {
        console.error(err)
      return(this.response_from_node = JSON.stringify(err));
      },
     () => {
          // then delete from SOP
        // console.log('Added Model: ', JSON.stringify(model));

// NO THIS IS A MUST AND HAS TO RUN!

      /// 08/02/24 Commented out as it was just creating errors and did nothing as above function sorted this anuyway....???
      // it is needed if not run the local payment details reamin etc..
      this.deletePaymentAndInvoicePaymentMyob(model); // passed model as normal.
      // console.log('Brand Loaded.')
      return true;
    }
    );
  } // end confirm
  }



  deletePaymentAndInvoicePayment(model) {
  // if (confirm('Are you sure you want to delete this payment entry?')) {
    this._demoService.deletePaymentAndInvoicePayment(model).subscribe(
      (data) => {
        this.invoice_deleted_data = data;
        let res = data[0];

              this.invoice_update_payment_model = {
                invoice_id: model.invoice_id,
                invoice_payment_total: '0.00',
                // invoice_remaining_total: model.invoice_total,
                invoice_remaining_total: model.payment_total, // set the total remaining back from the total that was paid.
                invoice_status_id: 3, // approved
                invoice_payment_status_id: 1, // outstanding
                updated_by: this.gfunc.sessionUserId,
                updated_date: this.gfunc.today
              };
      },
      (err) => {
        console.log(err.error)
      
      
          // // Need to set some error varibles
          // this.error_message = err.error.error_message;
          // this.error_message_standard = err.error.error_message_standard;
          // this.error_name = err.error.error_name;
          // this.full_response_data = err.error.full_response_data;
          // this.data_sent = err.error.data_sent;
          // this.data_sent_id = err.error.data_sent_invoice_id;

          this.response_from_node = JSON.stringify(err)
          this.response_from_node_raw = err;
          console.log('FullRespoonse Error createMyobWorkOrderModel(model, data_work_order): ' + this.response_from_node)
          return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
      
      }
      ,
     () => {
     this.updateInvoiceAfterPaymentFiguresLocal(this.invoice_update_payment_model);
      // this.refreshSujectInvoicePage(this.subject_id);
     }
    );
  // } // end confirm
  }
// // Loads from add new billing items modal.
// refreshInvoiceItemsBelow() {
//   console.log('Reloading Items');
//   this.getInvoiceItmes(this.invoice_id);
// }






deletePaymentAndInvoicePaymentMyob(model) {
  // if (confirm('Are you sure you want to delete this payment entry?')) {
    this._demoService.deletePaymentAndInvoicePayment(model)
    .pipe(
      this.toastr.observe({
        loading: 'Connecting...Pushing...Updating',
        success: '🚀',
        error: ''
     })
     )
    .pipe(
      retry(10), // you retry 3 times
      delay(1500) // each retry will start after 1 second,
   )
    .subscribe(
      (data) => {
        this.invoice_deleted_data = data;
        let res = data[0];

              this.invoice_update_payment_model = {
                invoice_id: model.invoice_id,
                invoice_payment_total: '0.00',
                // invoice_remaining_total: model.invoice_total,
                invoice_remaining_total: model.payment_total, // set the total remaining back from the total that was paid.
                invoice_status_id: 3, // approved
                invoice_payment_status_id: 1, // outstanding
                updated_by: this.gfunc.sessionUserId,
                updated_date: this.gfunc.today
              };
      },
      (err) => {
        console.log(err.error)
        return JSON.stringify(err);
      },
     () => {
     this.updateInvoiceAfterPaymentFigures(this.invoice_update_payment_model);
      // this.refreshSujectInvoicePage(this.subject_id);
     }
    );
  // } // end confirm
  }
// // Loads from add new billing items modal.
// refreshInvoiceItemsBelow() {
//   console.log('Reloading Items');
//   this.getInvoiceItmes(this.invoice_id);
// }






 refreshSujectInvoicePage(subject_id){
      this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
                    this.router.navigate(['/admin/jobs/subject/billing/' + subject_id + '']));
    }


// just updates local details
    updateInvoiceAfterPaymentFiguresLocal(model){
      this._demoService.updateInvoiceAfterPaymentFigures(model).subscribe(
        (data) => {
         // this.new_payment_id = data;
         let res = data[0];
    this.toastr.success('Payment + Invoice Record(s) Applied');
    this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id);
    },
    (err) => console.error(err),
    () => {
    }
    );
    }

    // updates local and online.
    updateInvoiceAfterPaymentFigures(model){
      this._demoService.updateInvoiceAfterPaymentFigures(model).subscribe(
        (data) => {
         // this.new_payment_id = data;
         let res = data[0];
    this.toastr.success('Payment + Invoice Record(s) Applied');
    // :: TOD refresh the invoice modal below.
    // // May need these but was causing a very slow system.
    // this.closeParentModel3.emit();
    // this.closeParentModel2.emit();
    // this.closeParentModel.emit();
    // this.refreshInvoiceItemsBelow.emit();
    },
    (err) => {
      console.error(err)
      return JSON.stringify(err);
  },
    () => {
      // end of delete
    // refresh/update the payment invoice versions after delete items. (seems to be buggy on delelte.)
this.gfunc.insertLog_DeleteInvoicePayment(model);
      console.log('Invoice Model at Del End: ' + JSON.stringify(model));
      // set the ID so the updates of invoice rowvrs can take place
      this.myobApi_IPTW.getSubjectInvoice(this.current_invoice_id); // runs function in another component before start.
      this.myobApi_IPTW.subject_id = this.subject_id; // to redirect the page back.
      this.myobApi_IPTW.getMyobAccountCodes();
      this.myobApi_IPTW.getMyobAccountCodes();
         console.log('model.UID', model.UID + this.current_invoiceUID);

   this.myobApi_ITW.lookupInvoiceUpdateInvoice2(this.current_paymentUID, model); // THIS WORKS.

  //  this.myobApi_ITW.lookupInvoiceUpdateInvoice2(model.UID, model); // THIS WORKS. - orginal was throwineg errors feb 2023 - wrong ID
 
    // this.refreshSujectInvoicePage(this.subject_id);
    }
    );
    }




    
 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}


}
